import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MessageState {
  value: string | null;
  timeout: number;
  type: 'info' | 'warning' | 'damage' | 'error' | 'ok' | 'offline';
  actions?: Array<{
    icon: string;
    onPress: () => void;
    text: string;
  }>;
}

const initialState: MessageState = {
  value: null,
  timeout: 0,
  type: 'info',
};

export const messageSlice = createSlice({
  name: 'message',
  initialState,
  reducers: {
    hideMessage: state => {
      state.value = null;
    },
    setMessage: (
      state,
      action: PayloadAction<{
        value: string;
        timeout?: number;
        type?: MessageState['type'];
        actions?: MessageState['actions'];
      }>
    ) => {
      state.value = action.payload.value;
      state.timeout = action.payload.timeout || 0;
      state.actions = action.payload.actions || [];
      state.type = action.payload.type || initialState.type;
    },
  },
});

export const { setMessage, hideMessage } = messageSlice.actions;

export const selectMessage = (state: any) => state.message;
export const selectMessageValue = (state: any) => state.message.value;

export default messageSlice.reducer;
